export default __webpack_public_path__ + "teams-desktop-top.25f402.png";